import * as dictionary from './../../design-tokens/build/dictionary';
// import * as dictionaryBase from './../../design-tokens/build/dictionary-base';
import demoVideo from './../assets/videos/20171216_002.mp4';
import heroVideo from './../assets/videos/ninja-hero.mp4';
import demoThumbnail from './../assets/images/test-thumbnail.png';


/**
 * @type {Boolean}
 *
 * True if this is dev
 */
export const DEV = process.env.NODE_ENV === 'development';

/**
 * @type {Boolean}
 *
 * True if this is staging
 */
export const STAGING = process.env.VUE_APP_GROW_ENV === 'staging';

/**
 * Demo video src
 */
export const videoDemo = demoVideo;

/**
 * Demo thumbnail src
 */
export const thumbnailDemo = demoThumbnail;


// /**
//  * styles needed for the interactive can slider
//  */
// export const SLIDER_VARS = {
//   thumbSize: dictionary.SIZE_WIDTH_SLIDER_THUMB,
//   thumbMarginTop: dictionary.SIZE_MARGIN_TOP_SLIDER_THUMB,
//   sliderWidth: dictionary.SIZE_WIDTH_SLIDER,
//   sliderHeight: dictionary.SIZE_HEIGHT_SLIDER,
//   sliderBorderWidth: dictionary.SIZE_BORDER_WIDTH_SLIDER,
//   sliderBorderRadius: dictionary.SIZE_BORDER_RADIUS_SLIDER,
//   borderColor: dictionaryBase.COLOR_BASE_WHITE_BASE,
//   backgroundColor: dictionaryBase.COLOR_BASE_NINJA_DARK_BLUE_BASE,
//   piecewiseWidth: dictionary.SIZE_WIDTH_PIECEWISE,
//   piecewiseHeight: dictionary.SIZE_HEIGHT_PIECEWISE,
//   piecewiseMarginTop: dictionary.SIZE_MARGIN_TOP_PIECEWISE,
// };


/**
 * Video.js Control bar items
 */
export const VIDEO_JS_CONTROL_BAR_CONFIG = {
  children: [
    'playToggle',
    'currentTimeDisplay',
    'timeDivider',
    'durationDisplay',
    'progressControl',
    'fullscreenToggle'
  ]
};

const heroControlBar = VIDEO_JS_CONTROL_BAR_CONFIG.children.slice(0);
heroControlBar.splice(1, 0, 'muteToggle');

/**
 * Config for the promo video in the hero
 */
export const HERO_VIDEO_CONFIG = {
  id: 'hero-video',
  src: heroVideo,
  aspectRatio: '16:9',
  height: 900,
  width: 1600,
  controlBar: {
    children: heroControlBar,
  }
};

/**
 * Names of routes
 */
export const ROUTE_NAMES = {
  home: 'home',
  entryForm: 'entryForm',
  entrySuccess: 'entrySuccess',
  terms: 'terms'
};

/**
 * Paths that match the names of routes
 */
export const ROUTE_PATHS = {
  [ROUTE_NAMES.home]: '/',
  [ROUTE_NAMES.entrySuccess]: '/success',
  [ROUTE_NAMES.entryForm]: '/enter',
  [ROUTE_NAMES.terms]: '/terms'
};

/**
 * Route get Param values
 */
export const ROUTE_QUERY_PARAMS = {
  submissionId: 'submission',
  section: 'section',
};

/**
 * Routes for the entry pages
 */
export const ENTRY_ROUTES = [
  ROUTE_NAMES.entryForm,
  ROUTE_NAMES.entrySuccess
];


/**
 * Token value for the redbull login sdk
 */
export const RB_LOGIN_TOKEN = process.env.VUE_APP_RB_LOGIN_TOKEN;

/**
 * Return path for the redbull login sdk, appended to the origin
 */
export const RB_LOGIN_RETURN_PATH = ROUTE_PATHS[ROUTE_NAMES.entryForm];


/**
 * The origin for share links and the iframe target in prod
 *
 * in dev it will be the same as the window, but the site will ultimately be served from ninja.redbull.com on redbull.com parent page
 */
export const LANDING_ORIGIN = process.env.NODE_ENV === 'development' ? window.location.origin : process.env.VUE_APP_PARENT_DOMAIN;

/**
 * Contest begin date
 */
export const CONTEST_ACTIVE_BEGIN = Date.UTC(2019, 3, 1, 7, 1);

/**
 * Contest end date
 */
export const CONTEST_ACTIVE_END = Date.UTC(2019, 5, 1, 6, 59);

/**
 * Should the contest be forced to being active.
 */
export const FORCE_CONTEST_ACTIVE = process.env.VUE_APP_CONTEST_ACTIVE === 'true';

/**
 * Base of Landing url for share links
 *
 */
export const LANDING_URL = `${LANDING_ORIGIN}[[path]]${ROUTE_PATHS.home}?${ROUTE_QUERY_PARAMS.submissionId}=`;

/**
 * Share url format for Twitter
 */
export const TWITTER_SHARE_TEMPLATE = 'https://twitter.com/intent/tweet?url=[[shareUrl]]&text=[[text]]';

/**
 * Share url format for Twitter
 */
export const FACEBOOK_SHARE_TEMPLATE = 'https://www.facebook.com/sharer/sharer.php?u=[[shareUrl]]';

/**
 * Error codes
 */
export const errors = {};

errors.SUBMISSION_NO = 'Submission empty.';
errors.SUBMISSION_INVALID = 'Submission invalid.';
errors.SUBMISSION_MODERATION_FAILED = 'Submission flagged.';
errors.SUBMISSION_SERVER_ERROR = 'Submission server error.';
errors.SUBMISSION_LIMIT = 'User over submission limit.';
errors.SUBMISSION_NOT_FOUND = 'Submission not found';
errors.SUBMISSION_LOAD_FAILURE = 'Submission load failed';
errors.SUBMISSIONS_NONE = 'No more submissions';
errors.USER_LOGIN = 'User login error';
errors.USER_LOGIN_NO = 'User not logged in.';
errors.UPLOAD_UNSUPPORTED = 'Browser does not support uploading';
errors.UPLOAD_TYPE_INVALID = 'Wrong file type loaded';
errors.UPLOAD_SIZE_INVALID = 'File size invalid (too large or zero)';
errors.UPLOAD_TERMS = 'User must accept terms';
errors.UPLOAD_DURATION_INVALID = 'Duration invalid, too long.';
errors.UPLOAD_OPEN = 'Could not open file.';
errors.UPLOAD_OPEN_VIDEO = 'Could not open video file.';

/**
 * Width of submissions in px
 */
export const SUBMISSION_WIDTH = parseFloat(dictionary.RATIO_WIDTH_IMAGE_SUBMISSION) * 10;

/**
 * Width of submissions in px
 */
export const SUBMISSION_HEIGHT = parseFloat(dictionary.RATIO_HEIGHT_IMAGE_SUBMISSION) * 10;

/**
 * Submission aspect ratio
 */
export const SUBMISSION_RATIO = SUBMISSION_WIDTH / SUBMISSION_HEIGHT;

/**
 * Pattern to test valid upload types
 */
export const SUBMISSION_UPLOAD_TYPE_PATTERN = /^(?:(image)\/(?:jpeg?|png))|(?:(video)\/(mp4|x-m4v|quicktime))/;

/**
 * Parse image ratio
 */
export const RATIO_PATTERN = /(.*):(.*)/;

/**
 * MIME type to export images as
 */
export const SUBMISSION_IMAGE_TYPE = 'image/png';

/**
 * How fast to update the video preview canvas
 */
export const SUBMISSION_VIDEO_DRAW_SPEED = 20; // submission video draw speed in ms

/**
 * Categories for submissions
 */
export const SUBMISSION_CATEGORIES = {
  video: 'video',
  image: 'image'
};

/**
 * Entry form error messages
 */
export const ENTRY_FORM_MESSAGES = {
  [errors.UPLOAD_TYPE_INVALID]: dictionary.CONTENT_PROMPT_TYPE_INVALID,
  [errors.UPLOAD_SIZE_INVALID]: dictionary.CONTENT_PROMPT_SIZE_INVALID,
  [errors.SUBMISSION_MODERATION_FAILED]: dictionary.CONTENT_PROMPT_MODERATION_FAILED,
  [errors.UPLOAD_TERMS]: dictionary.CONTENT_PROMPT_TERMS_FAILED,
  [errors.UPLOAD_DURATION_INVALID]: dictionary.CONTENT_PROMPT_DURATION_INVALID,
  [errors.UPLOAD_OPEN_VIDEO]: dictionary.CONTENT_PROMPT_VIDEO_ERROR,
  quicktime: dictionary.CONTENT_PROMPT_QUICKTIME_SUCCESS,
};

/**
 * How many thumbnail choices to give the user
 */
export const ENTRY_FORM_THUMBNAIL_CHOICES = 3;

/**
 * submission status codes
 */
export const submissionStatuses = {
  PENDING: 'PENDING',
  LIVE: 'LIVE',
  FLAGGED: 'FLAGGED',
  REPORTED: 'REPORTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

/**
 * Headlines on success screen for submission status
 */
export const ENTRY_SUCCESS_HEADLINES = {
  [submissionStatuses.PENDING]: dictionary.CONTENT_ENTRY_SUCCESS_HEADLINE_BASE,
  [submissionStatuses.LIVE]: dictionary.CONTENT_ENTRY_SUCCESS_HEADLINE_BASE,
  [submissionStatuses.FLAGGED]: dictionary.CONTENT_ENTRY_SUCCESS_HEADLINE_FLAGGED,
  [submissionStatuses.REPORTED]: dictionary.CONTENT_ENTRY_SUCCESS_HEADLINE_REPORTED,
  [submissionStatuses.APPROVED]: dictionary.CONTENT_ENTRY_SUCCESS_HEADLINE_BASE,
  [submissionStatuses.REJECTED]: dictionary.CONTENT_ENTRY_SUCCESS_HEADLINE_REJECTED,
};

/**
 * Body copy on success screen for submission status
 */

export const ENTRY_SUCCESS_BODY_COPY = {
  [submissionStatuses.PENDING]: dictionary.CONTENT_ENTRY_SUCCESS_BODY_BASE,
  [submissionStatuses.LIVE]: dictionary.CONTENT_ENTRY_SUCCESS_BODY_BASE,
  [submissionStatuses.FLAGGED]: dictionary.CONTENT_ENTRY_SUCCESS_BODY_FLAGGED,
  [submissionStatuses.REPORTED]: dictionary.CONTENT_ENTRY_SUCCESS_BODY_REPORTED,
  [submissionStatuses.APPROVED]: dictionary.CONTENT_ENTRY_SUCCESS_BODY_BASE,
  [submissionStatuses.REJECTED]: dictionary.CONTENT_ENTRY_SUCCESS_BODY_REJECTED,
};

/**
 * Messages on expaned submission view for submission status
 */
export const SUBMISSION_STATUS_MESSAGES = {
  [submissionStatuses.PENDING]: dictionary.CONTENT_SUBMISSION_STATUS_PENDING_BASE,
  [submissionStatuses.LIVE]: dictionary.CONTENT_SUBMISSION_STATUS_LIVE_BASE,
  [submissionStatuses.FLAGGED]: dictionary.CONTENT_SUBMISSION_STATUS_FLAGGED_BASE,
  [submissionStatuses.REPORTED]: dictionary.CONTENT_SUBMISSION_STATUS_REPORTED_BASE,
  [submissionStatuses.APPROVED]: dictionary.CONTENT_SUBMISSION_STATUS_APPROVED_BASE,
  [submissionStatuses.REJECTED]: dictionary.CONTENT_SUBMISSION_STATUS_REJECTED_BASE,
};

/**
 * How many submissions to request at a time
 */
export const SUBMISSIONS_PAGE_SIZE = 24;

/**
 * We always want to have this many submissions to go forwards to, if available
 */
export const SUBMISSIONS_BUFFER_SIZE = 24;


/**
 * Messages for submission errors, not statuses
 */
export const SUBMISSION_ERROR_MESSAGES = {
  [errors.SUBMISSION_NOT_FOUND]: dictionary.CONTENT_SUBMISSION_ERROR_NOT_FOUND,
  [errors.SUBMISSION_LOAD_FAILURE]: dictionary.CONTENT_SUBMISSION_ERROR_LOAD_FAILURE,
};
